import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '../../query'
import { CheckoutRequest } from './types'

export const checkoutApi = createApi({
  reducerPath: 'checkout',
  baseQuery,
  endpoints: (builder) => ({
    finishCheckout: builder.mutation<void, CheckoutRequest>({
      query: (data) => ({
        url: '/api/checkout/finish',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { useFinishCheckoutMutation } = checkoutApi
